<template>
	<app-table :columns="columns" :data="restaurants" :loading="loading">
		<template v-slot:status="{ item }">
			<POSBusinessStatus
				:business-id="item.restaurantID"
				:city-id="item.city.id"
				:businessClosingTime="item.closingTime"
				:online="item.status === 1"
			/>
		</template>
		<template v-slot:menu="{ item }">
			<div class="flex flex-row">
				<app-tooltip v-if="canEditExtraDeliveryTime" text="Extra Delivery Time">
					<app-button
						icon="clock"
						:class="
							`btn btn-primary small text-13 mr-1 ${
								item.extraDeliveryTime.extraTime ? 'animate-pulse' : 'transparent'
							}`
						"
						:loading="loading"
						@click="$emit('openExtraDeliveryTimeModal', item)"
					/>
				</app-tooltip>

				<app-tooltip text="Menu">
					<app-button
						icon="trello"
						class="btn btn-primary transparent small text-13 mr-1"
						:loading="loading"
						@click="$emit('openMenu', item)"
					/>
				</app-tooltip>
				<app-tooltip text="Toppings">
					<app-button
						icon="doc"
						class="btn btn-primary transparent small text-13 mr-1"
						:loading="loading"
						@click="$emit('openToppings', item)"
					/>
				</app-tooltip>
				<app-tooltip v-if="canViewTopProducts" :text="$t('top_products')">
					<app-button
						icon="shopping-basket"
						class="btn btn-primary transparent small text-13 mr-1"
						:loading="loading"
						@click="$emit('openTopProducts', item)"
					/>
				</app-tooltip>
			</div>
		</template>
	</app-table>
</template>

<script>
	import AppTable from '@/components/app/AppTable';
	import RouteNames from '@/router/names';
	import restaurants from '@/constants/business';
	import AppButton from '@/components/app/AppButton';
	import POSBusinessStatus from '@/components/POSBusinessStatus';
	import BusinessService from '@/services/sales/BusinessService';
	import AppTooltip from '@/components/app/AppTooltip.vue';
	import { checkUserTypeAccess, MANAGER, OWNER, SUPER_ADMIN } from '@/middlewares/permissions';

	export default {
		name: 'BusinessTable',
		components: {
			AppTooltip,
			POSBusinessStatus,
			AppButton,
			AppTable,
		},
		computed: {
			canEditExtraDeliveryTime() {
				return BusinessService.canEditExtraDeliveryTime();
			},
			canViewTopProducts() {
				return checkUserTypeAccess([MANAGER, OWNER, SUPER_ADMIN]);
			},
		},
		props: {
			restaurants: {
				type: Array,
				required: true,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			businessIDs: {},
		},
		data: () => ({
			RouteNames,
			columns: restaurants.columns,
			selectedBusinessId: null,
			loadingStatusChange: false,
			availableBusinessStatuses: [],
		}),
	};
</script>
